module.exports = __webpack_public_path__ + "static/media/3.27577c4e.jpg";